import { useEffect } from "react";
import auth from "../services/authService";
import http from "../services/http";

const Logout = () => {
  useEffect(() => {
    auth.logout();
    window.location = "/";
    http.delete("/auth");
  }, []);
  return null;
};

export default Logout;
